/* ForeFrontier: Hole of the Day */
(function () {
  'use strict';
  var root = document.querySelector('[data-game]');
  if (!root) return;

  var canvas = root.querySelector('[data-game-canvas]');
  var ctx = canvas.getContext('2d');
  var swingBtn = root.querySelector('[data-game-swing]');
  var meterWrap = root.querySelector('[data-game-meter-wrap]');
  var meter = root.querySelector('[data-game-meter]');
  var statusEl = root.querySelector('[data-game-status]');
  var shotsEl = root.querySelector('[data-game-shots]');
  var claimPanel = root.querySelector('[data-game-claim]');
  var claimTitle = root.querySelector('[data-game-claim-title]');
  var rewardPanel = root.querySelector('[data-game-reward]');
  var rewardLabel = root.querySelector('[data-game-reward-label]');
  var rewardNote = root.querySelector('[data-game-reward-note]');
  var codeEl = root.querySelector('[data-game-code]');
  var copyBtn = root.querySelector('[data-game-copy]');
  var applyLink = root.querySelector('[data-game-apply]');
  var form = document.getElementById('game-signup');
  var postedEl = root.querySelector('[data-game-posted]');

  var CODES = (window.FF && window.FF.codes) || {};
  var TIERS = { t5: 5, t10: 10, t15: 15 };
  var SHOTS_PER_DAY = 3;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* storage */
  function load(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } }
  function save(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function drop(k) { try { localStorage.removeItem(k); } catch (e) {} }

  /* today's hole, the same for everyone */
  var now = new Date();
  var today = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();
  function hash(s) { var h = 2166136261; for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; }
  function seeded(a) { return function () { a |= 0; a = a + 0x6D2B79F5 | 0; var t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  var rand = seeded(hash('ff' + today));
  var PIN = Math.round(118 + rand() * 44);
  var WIND = Math.round((rand() * 12 - 6) * 10) / 10;
  var HOLE = 1 + (hash(today) % 18);

  var day = load('ff_day');
  if (!day || day.date !== today) day = { date: today, shots: 0, best: null, trail: [] };
  var reward = load('ff_reward');
  if (reward && !CODES[reward.tier]) reward = null;
  var claimed = load('ff_claimed') === true;

  /* canvas: a wide plate on desktop, a compact one on phones */
  var W, H, TEE_X, GROUND, SCALE, FS;
  var MAX_M = 205;
  var C = { ink: '#1B2336', line: 'rgba(222,212,196,0.92)', faint: 'rgba(222,212,196,0.26)', brass: '#C9A06A', chalk: '#F3F1EC' };
  var SANS = '"Instrument Sans", system-ui, sans-serif';
  var SERIF = '"Libre Caslon Text", Georgia, serif';
  function setup() {
    var compact = (canvas.parentNode.clientWidth || 900) < 620;
    W = compact ? 520 : 900; H = compact ? 500 : 470; FS = compact ? 1.45 : 1;
    TEE_X = compact ? 52 : 96; GROUND = compact ? 300 : 330;
    SCALE = (W - (compact ? 40 : 70) - TEE_X) / MAX_M;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = W * dpr; canvas.height = H * dpr;
    canvas.style.aspectRatio = W + ' / ' + H;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  function fs(n) { return Math.round(n * FS); }
  function mx(m) { return TEE_X + m * SCALE; }
  setup();

  var state = 'ready';
  var power = 0, chargeStart = 0;
  var shot = null;

  function text(str, x, y, font, color, align) {
    ctx.font = font; ctx.fillStyle = color; ctx.textAlign = align || 'left'; ctx.fillText(str, x, y);
  }
  function arrowHead(x, y, dir) {
    ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x - 7 * dir, y - 3.5); ctx.lineTo(x - 7 * dir, y + 3.5); ctx.closePath(); ctx.fill();
  }
  function dimension(x1, x2, y, label, color) {
    ctx.strokeStyle = color; ctx.fillStyle = color; ctx.lineWidth = 1;
    ctx.beginPath(); ctx.moveTo(x1, y); ctx.lineTo(x2, y); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(x1, y - 7); ctx.lineTo(x1, y + 7); ctx.moveTo(x2, y - 7); ctx.lineTo(x2, y + 7); ctx.stroke();
    if (Math.abs(x2 - x1) > 18) { arrowHead(x2, y, x2 > x1 ? 1 : -1); arrowHead(x1, y, x2 > x1 ? -1 : 1); }
    var mid = (x1 + x2) / 2;
    ctx.font = 'italic ' + fs(15) + 'px ' + SERIF;
    var w = ctx.measureText(label).width + 14, bh = fs(20);
    ctx.fillStyle = C.ink; ctx.fillRect(mid - w / 2, y - bh / 2 - 1, w, bh);
    text(label, mid, y + fs(5), 'italic ' + fs(15) + 'px ' + SERIF, color, 'center');
  }

  function drawScene() {
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = C.ink; ctx.fillRect(0, 0, W, H);

    ctx.strokeStyle = C.faint; ctx.lineWidth = 1; ctx.strokeRect(14.5, 14.5, W - 29, H - 29);
    ctx.strokeStyle = C.line; ctx.lineWidth = 0.8; ctx.strokeRect(22.5, 22.5, W - 45, H - 45);

    text('PLATE IV', 40, 52, '600 ' + fs(11) + 'px ' + SANS, C.line);
    text(W < 700 ? 'GENEVA' : 'FOREFRONTIER   GENEVA', W - 40, 52, '600 ' + fs(11) + 'px ' + SANS, C.line, 'right');

    /* wind */
    var wx = W / 2, wy = W < 700 ? 104 : 92;
    var wtxt = WIND === 0 ? 'Calm today' : Math.abs(WIND).toFixed(1) + ' m/s ' + (WIND > 0 ? 'helping' : 'against');
    text('Wind', wx, wy - fs(22), '500 ' + fs(12) + 'px ' + SANS, C.faint.replace('0.26', '0.7'), 'center');
    text(wtxt, wx, wy + fs(26), 'italic ' + fs(15) + 'px ' + SERIF, C.line, 'center');
    if (WIND !== 0) {
      var len = 26 + Math.abs(WIND) * 9, dir = WIND > 0 ? 1 : -1;
      ctx.strokeStyle = C.line; ctx.fillStyle = C.line; ctx.lineWidth = 1.2;
      ctx.beginPath(); ctx.moveTo(wx - len / 2 * dir, wy); ctx.lineTo(wx + len / 2 * dir, wy); ctx.stroke();
      arrowHead(wx + len / 2 * dir + 2 * dir, wy, dir);
    }

    /* scale bar, like the one on a drawing */
    var sy = W < 700 ? 176 : 168;
    ctx.strokeStyle = C.faint; ctx.fillStyle = C.faint; ctx.lineWidth = 1;
    ctx.beginPath(); ctx.moveTo(mx(0), sy); ctx.lineTo(mx(200), sy);
    for (var sm = 0; sm <= 200; sm += 25) { var tk = sm % 50 === 0 ? 7 : 4; ctx.moveTo(mx(sm), sy - tk); ctx.lineTo(mx(sm), sy + tk); }
    ctx.stroke();
    for (var sl = 0; sl <= 200; sl += (W < 700 ? 100 : 50)) text(sl + (sl === 200 && W >= 700 ? ' m' : ''), mx(sl), sy - 14, '500 ' + fs(11) + 'px ' + SANS, 'rgba(222,212,196,0.55)', 'center');

    /* ground and hatching */
    ctx.strokeStyle = C.line; ctx.lineWidth = 1.2;
    ctx.beginPath(); ctx.moveTo(44, GROUND); ctx.lineTo(W - 44, GROUND); ctx.stroke();
    ctx.strokeStyle = C.faint; ctx.lineWidth = 1;
    ctx.beginPath();
    for (var hx = 50; hx < W - 50; hx += 13) { ctx.moveTo(hx, GROUND + 2); ctx.lineTo(hx - 9, GROUND + 11); }
    ctx.stroke();

    /* green */
    var g1 = mx(PIN - 14), g2 = mx(PIN + 14);
    ctx.strokeStyle = C.line; ctx.lineWidth = 3.5;
    ctx.beginPath(); ctx.moveTo(g1, GROUND - 1.5); ctx.lineTo(g2, GROUND - 1.5); ctx.stroke();
    text('Green', (g1 + g2) / 2, GROUND + fs(30), '500 ' + fs(12) + 'px ' + SANS, C.line, 'center');

    /* tee */
    ctx.strokeStyle = C.line; ctx.lineWidth = 1.4;
    ctx.beginPath(); ctx.moveTo(TEE_X, GROUND); ctx.lineTo(TEE_X, GROUND - 7); ctx.moveTo(TEE_X - 5, GROUND - 7); ctx.lineTo(TEE_X + 5, GROUND - 7); ctx.stroke();
    text('Tee', TEE_X, GROUND + fs(30), '500 ' + fs(12) + 'px ' + SANS, C.line, 'center');

    /* flag */
    var fx = mx(PIN);
    ctx.fillStyle = C.ink; ctx.fillRect(fx - 4, GROUND - 1, 8, 4);
    ctx.strokeStyle = C.line; ctx.lineWidth = 1.4;
    ctx.beginPath(); ctx.moveTo(fx, GROUND); ctx.lineTo(fx, GROUND - 78); ctx.stroke();
    ctx.fillStyle = C.brass;
    ctx.beginPath(); ctx.moveTo(fx, GROUND - 78); ctx.lineTo(fx + 24, GROUND - 70); ctx.lineTo(fx, GROUND - 62); ctx.closePath(); ctx.fill();

    /* distance to pin */
    dimension(TEE_X, fx, GROUND + (W < 700 ? 84 : 62), PIN + ' m', C.line);

    /* earlier shots today */
    ctx.fillStyle = C.faint;
    (day.trail || []).forEach(function (m) { ctx.beginPath(); ctx.arc(mx(Math.min(m, MAX_M)), GROUND - 4, 3, 0, Math.PI * 2); ctx.fill(); });

    /* live shot */
    if (shot) {
      ctx.setLineDash([4, 5]); ctx.strokeStyle = C.line; ctx.lineWidth = 1;
      ctx.beginPath();
      for (var i = 0; i < shot.path.length; i++) { var p = shot.path[i]; if (i) ctx.lineTo(p[0], p[1]); else ctx.moveTo(p[0], p[1]); }
      ctx.stroke(); ctx.setLineDash([]);
      if (!shot.holedNow) {
        ctx.fillStyle = C.chalk; ctx.beginPath(); ctx.arc(shot.bx, shot.by, 5, 0, Math.PI * 2); ctx.fill();
      }
      if (shot.done && !shot.holed && shot.final <= MAX_M) {
        dimension(Math.min(shot.bx, fx), Math.max(shot.bx, fx), GROUND - 24, shot.dist.toFixed(1) + ' m', C.brass);
      }
    } else {
      ctx.fillStyle = C.chalk; ctx.beginPath(); ctx.arc(TEE_X, GROUND - 12, 5, 0, Math.PI * 2); ctx.fill();
    }

    text("The hole of the day", 40, H - 40, 'italic ' + fs(17) + 'px ' + SERIF, C.line);
    text('Hole ' + HOLE + '    Par 3', W - 40, H - 40, '500 ' + fs(12) + 'px ' + SANS, C.line, 'right');
  }

  /* swinging */
  function shotsLeft() { return Math.max(0, SHOTS_PER_DAY - day.shots); }
  function updateShots() {
    var left = shotsLeft();
    shotsEl.textContent = left ? left + (left === 1 ? ' swing left today' : ' swings left today') : 'No swings left today. A new hole opens tomorrow.';
    swingBtn.disabled = !left || state === 'flying';
    if (!left) swingBtn.textContent = 'Back tomorrow';
  }

  function startCharge() {
    if (state !== 'ready' || !shotsLeft()) return;
    state = 'charging'; chargeStart = performance.now(); shot = null;
    swingBtn.textContent = 'Let go to hit';
    requestAnimationFrame(chargeLoop);
  }
  function chargeLoop(t) {
    if (state !== 'charging') return;
    var phase = ((t - chargeStart) / 1500) % 2;
    power = phase < 1 ? phase : 2 - phase;
    meter.style.transform = 'scaleX(' + power.toFixed(3) + ')';
    meterWrap.setAttribute('aria-valuenow', Math.round(power * 100));
    drawScene();
    requestAnimationFrame(chargeLoop);
  }
  function release() {
    if (state !== 'charging') return;
    state = 'flying';
    swingBtn.textContent = 'Hold to swing';
    var carry = 40 + power * 150 + WIND * 2.2;
    var roll = 2 + power * 3 + (Math.random() - 0.5) * 2;
    var final = Math.max(0, carry + roll);
    var dist = Math.abs(final - PIN);
    var holed = dist <= 0.3;
    if (holed) { final = PIN; dist = 0; }
    shot = { carry: carry, final: final, dist: dist, holed: holed, path: [], bx: TEE_X, by: GROUND - 12, done: false };
    day.shots += 1;
    updateShots();
    animateShot();
  }

  function animateShot() {
    var flightMs = reduceMotion ? 1 : 1400, rollMs = reduceMotion ? 1 : 600;
    var apex = Math.min(shot.carry * 0.3, 52);
    var start = performance.now();
    function frame(t) {
      var e = t - start;
      if (e < flightMs) {
        var k = e / flightMs, m = Math.min(shot.carry * k, MAX_M + 8);
        var h = 4 * apex * k * (1 - k);
        shot.bx = mx(m); shot.by = GROUND - 5 - h * SCALE * 0.9;
        shot.path.push([shot.bx, shot.by]);
      } else if (e < flightMs + rollMs) {
        var r = (e - flightMs) / rollMs, ease = 1 - Math.pow(1 - r, 3);
        var mm = shot.carry + (shot.final - shot.carry) * ease;
        shot.bx = mx(Math.min(mm, MAX_M + 8)); shot.by = GROUND - 5;
      } else {
        shot.bx = mx(Math.min(shot.final, MAX_M + 8)); shot.by = GROUND - 5;
        shot.done = true; shot.holedNow = shot.holed;
        drawScene(); finishShot(); return;
      }
      drawScene(); requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function tierFor(dist) { return dist === 0 ? 't15' : dist <= 3 ? 't10' : 't5'; }

  function finishShot() {
    state = 'ready';
    day.trail = (day.trail || []).concat([shot.final]);
    if (day.best === null || shot.dist < day.best) day.best = shot.dist;
    save('ff_day', day);

    var tier = tierFor(shot.dist);
    var d = shot.dist.toFixed(1);
    var side = shot.final > PIN ? 'long' : 'short';
    var msg;
    if (shot.holed) msg = 'In the hole. A hole in one is worth 15% off.';
    else if (shot.final > MAX_M) msg = 'Over the back and off the plate. Ease off a little.';
    else if (tier === 't10') msg = d + ' m ' + side + '. Inside 3 metres, so that\u2019s 10% off.';
    else msg = d + ' m ' + side + '. Get inside 3 metres for 10% off.';
    statusEl.textContent = msg;
    updateShots();
    offer(tier);
  }

  /* rewards: one code at a time, only ever upgraded */
  function better(a, b) { return !b || TIERS[a] > TIERS[b]; }

  function offer(tier) {
    if (!CODES[tier]) return;
    var current = reward && reward.tier;
    if (!better(tier, current)) {
      if (!claimed) showClaim(current || tier);
      return;
    }
    if (claimed) { setReward(tier, current); }
    else { save('ff_pending', tier); showClaim(tier); }
  }

  function showClaim(tier) {
    claimTitle.textContent = 'Claim ' + TIERS[tier] + '% off';
    claimPanel.hidden = false;
  }

  function setReward(tier, replaced) {
    reward = { tier: tier, date: today };
    save('ff_reward', reward);
    showReward(replaced && replaced !== tier ? replaced : null);
  }

  function showReward(replaced) {
    if (!reward) return;
    var code = CODES[reward.tier];
    claimPanel.hidden = true;
    rewardPanel.hidden = false;
    rewardLabel.textContent = TIERS[reward.tier] + '% off your order';
    codeEl.textContent = code;
    applyLink.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURI(root.getAttribute('data-apply-path') || '/cart');
    rewardNote.textContent = replaced
      ? 'This replaces your ' + TIERS[replaced] + '% code. One code per order.'
      : (reward.tier === 't15' ? 'The best there is. One code per order.' : 'One code per order. Play again tomorrow for a better one.');
  }

  /* returning from the email form */
  (function handlePost() {
    var pending = load('ff_pending');
    var posted = (postedEl && postedEl.getAttribute('data-game-posted') === 'true') || /customer_posted=true/.test(location.search);
    var errs = postedEl ? postedEl.getAttribute('data-game-errors') || '' : '';
    if (pending && (posted || /taken|already/i.test(errs))) {
      claimed = true; save('ff_claimed', true); drop('ff_pending');
      var prev = reward && reward.tier;
      if (better(pending, prev)) setReward(pending, prev); else showReward(null);
      if (root.scrollIntoView) root.scrollIntoView({ block: 'start' });
    } else if (pending && errs) {
      showClaim(pending);
      if (root.scrollIntoView) root.scrollIntoView({ block: 'start' });
    } else if (reward) {
      showReward(null);
    }
  })();

  if (form) form.addEventListener('submit', function () {
    if (!load('ff_pending')) save('ff_pending', (reward && reward.tier) || 't5');
  });

  copyBtn.addEventListener('click', function () {
    var code = codeEl.textContent;
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(function () { copyBtn.textContent = 'Copied'; setTimeout(function () { copyBtn.textContent = 'Copy'; }, 1600); });
  });

  /* input */
  swingBtn.addEventListener('pointerdown', function (e) { e.preventDefault(); startCharge(); });
  window.addEventListener('pointerup', release);
  window.addEventListener('pointercancel', release);
  swingBtn.addEventListener('contextmenu', function (e) { e.preventDefault(); });
  var spaceDown = false;
  function inView() { var r = root.getBoundingClientRect(); return r.top < window.innerHeight && r.bottom > 0; }
  window.addEventListener('keydown', function (e) {
    if ((e.code === 'Space' || e.key === ' ') && inView() && !/INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName)) {
      e.preventDefault(); if (!spaceDown) { spaceDown = true; startCharge(); }
    }
  });
  window.addEventListener('keyup', function (e) {
    if (e.code === 'Space' || e.key === ' ') { if (spaceDown) { spaceDown = false; release(); } }
  });

  var redraw = function () { drawScene(); };
  var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { if (state !== 'charging' && state !== 'flying') { setup(); drawScene(); } }, 150); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(redraw);
  updateShots();
  drawScene();
})();
